import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastControllerService {

  public toast: HTMLIonToastElement | null = null;

  constructor(private toastCtrl: ToastController) { }

  /**
   * Toast para mostrar mensajes o advertencias a la app
   * @param messageText Mensaje a mostrar
   * @param themeColor Color del toast
   * @param iconText Icono del toast
   * @param durationToast duracion a mostrar
   * @param clase Clase o stilos a heredar
   * @param position en que posición de mostrara el toast 'top' | 'middle' | 'bottom'
   */
  public presentToast = async (messageText: string, themeColor: string | null, iconText: string, durationToast: number, clase: string, position?: toastPosition, header?: string) => {
    this.toast = await this.toastCtrl.create({
      header,
      message: messageText || '',
      position: position || 'bottom',
      duration: durationToast || 3000,
      mode: 'ios',
      color: themeColor || 'grayDemon',
      cssClass: clase || '',
      buttons: [
        {
          side: 'start',
          icon: iconText,
          text: '',
          handler: () => {
            return false
          }
        },
        {
          icon: 'close',
          text: '',
          role: 'cancel',
          handler: () => { }
        }
      ]
    })

    await this.toast.present()
  }

  /**
   * Deseche la superposición de toast después de que se haya presentado
   */
  public dismissToast = async () => {
    if (this.toast) {
      await this.toast.dismiss();
      this.toast = null;
    }
    const tctrl = await this.toastCtrl.getTop();
    if (tctrl) {
      tctrl.dismiss();
    }
  }

}

type toastPosition = 'top' | 'middle' | 'bottom';
